import { Outlet, Link } from 'react-router-dom'

const AuthLayout = () => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-50 to-gray-100 flex">
      {/* Left side - Branding */}
      <div className="hidden lg:flex lg:w-1/2 bg-gradient-to-br from-blue-600 via-blue-700 to-indigo-800 relative overflow-hidden">
        <div className="absolute inset-0 bg-black/20"></div>
        <div className="relative z-10 flex flex-col justify-center px-12 text-white">
          <div className="mb-8">
            <h1 className="text-4xl font-bold mb-4">DaChauffeur</h1>
            <p className="text-xl text-blue-100">Premium Transportation Services</p>
          </div>
          
          <div className="space-y-6">
            <div className="flex items-start space-x-4">
              <div className="flex-shrink-0 w-12 h-12 bg-white/20 rounded-lg flex items-center justify-center">
                <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                </svg>
              </div>
              <div>
                <h3 className="text-lg font-semibold">Professional Chauffeurs</h3>
                <p className="text-blue-100">Experienced, licensed, and courteous drivers</p>
              </div>
            </div>
            
            <div className="flex items-start space-x-4">
              <div className="flex-shrink-0 w-12 h-12 bg-white/20 rounded-lg flex items-center justify-center">
                <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
                </svg>
              </div>
              <div>
                <h3 className="text-lg font-semibold">Punctual Service</h3>
                <p className="text-blue-100">Always on time, every time</p>
              </div>
            </div>
            
            <div className="flex items-start space-x-4">
              <div className="flex-shrink-0 w-12 h-12 bg-white/20 rounded-lg flex items-center justify-center">
                <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                </svg>
              </div>
              <div>
                <h3 className="text-lg font-semibold">Luxury Fleet</h3>
                <p className="text-blue-100">Premium vehicles for ultimate comfort</p>
              </div>
            </div>
          </div>
          
          <div className="mt-12 text-sm text-blue-100">
            <p>24/7 Customer Support</p>
            <p className="mt-1">Licensed & Insured</p>
          </div>
        </div>
        
        {/* Decorative elements */}
        <div className="absolute top-10 right-10 w-32 h-32 bg-white/10 rounded-full blur-xl"></div>
        <div className="absolute bottom-10 left-10 w-48 h-48 bg-white/10 rounded-full blur-xl"></div>
      </div>
      
      {/* Right side - Auth forms */}
      <div className="flex-1 flex items-center justify-center px-4 sm:px-6 lg:px-8">
        <div className="max-w-md w-full">
          {/* Logo for mobile */}
          <div className="lg:hidden text-center mb-8">
            <h1 className="text-3xl font-bold text-gray-900">DaChauffeur</h1>
            <p className="text-gray-600">Premium Transportation</p>
          </div>
          
          {/* Auth form container */}
          <div className="bg-white rounded-2xl shadow-xl p-8">
            <Outlet />
          </div>
          
          {/* Footer links */}
          <div className="mt-6 text-center text-sm text-gray-500">
            <p>&copy; 2024 DaChauffeur. All rights reserved.</p>
            <div className="mt-2 space-x-4">
              <Link to="/privacy-policy" className="hover:text-gray-700">Privacy Policy</Link>
              <Link to="/terms-of-use" className="hover:text-gray-700">Terms of Service</Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default AuthLayout
